module.exports = __webpack_public_path__ + "img/google-icon.df4a4d1d.png";